import { useState, useEffect } from 'react'
import Header from './Header'
import ListCart from './ListCart'
import Footer from './Footer'
import FormPayu from './FormPayu'
import TarjetasGuardadas from './TarjetasGuardadas'



const PagePayment = ({user,validateproductos,itemshopping,resumen,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal,form}) =>{
	const [metodoPago, setMetodoPago] = useState("")
	const [pasarelas, setPasarelas] = useState([])
	const [cards, setCards ] = useState([])
	const [pagoCuotas, setPagoCuotas ] = useState(false)
	
	const synCards =(data) =>{
		setCards(data)
	}

	
	const showModalDeposito = (item) => {
		setMetodoPago("manual")
		window.$("#modalConfrmpay").modal("show")
	}

	const handledeleteItem = (item) => {
	  window.Swal.fire({
	    title: '¿Estas Seguro de eliminar tu tarjeta?',
	    icon: 'warning',
	    showCancelButton: true,
	    cancelButtonColor: "#666",
	    confirmButtonColor: "#13a538",
	    confirmButtonText: 'Si',
	    cancelButtonText: "No"
	  }).then((result) => {
	    if (result.isConfirmed) {
	      deleteCard(item)
	    }
	  })
	}

	const getMyCards = async () => {
        if ( window.getCookie("commerce_lead_token") !== "" && window.getCookie("commerce_lead_token") !== undefined ) {

	        var myHeaders = new Headers();
	        myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );
	        const response = await fetch(window.path_service+"/metodo_pago/mylist/cart",{method:'POST', headers: myHeaders })	  
	        const data = await response.json()
	        console.log(data)
	        
	        if ( data.hasOwnProperty("status") && data.status && data.hasOwnProperty("data") && data.data.length > 0 ) {
			  	synCards(data.data)
			  	window.cards = data.data;
			}

        }
	};

	const deleteCard = async (item) =>{
		if ( window.getCookie("commerce_lead_token") !== "" && window.getCookie("commerce_lead_token") !== undefined ) {

		    var myHeaders = new Headers();
		    myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );
			const dataq = new FormData();
		    dataq.append("token", item.token );
		    const response = await fetch(window.path_service+"/metodo_pago/user/delete_my_card",{method:'POST',body:  dataq, headers: myHeaders })	  
		    const data = await response.json()

		  if ( data.hasOwnProperty("status") && data.status  ) {
		  	window.Swal.fire({
		          icon: 'success',
		          title: data.message,
		          showConfirmButton: false,
		          timer: 2500
		    });   	  	
		    getMyCards()
		  }else{
		  	window.Swal.fire({
		          icon: 'error',
		          title: "Surgio un error inesperado, intentalo nuevamente",
		          showConfirmButton: false,
		          timer: 2500
		    });   	  	
		  }

		}
	}


	useEffect(() => {
		if( [undefined,"undefined",""].includes(localStorage.paymnet_shipping) ){
			alert("Debes de seleccionar una Fecha de despacho");
			if (form === "apppayment") {
				window.location.href = "/app/despacho";
			}else{
				window.location.href = "/despacho";
			}
		}

		if (form === "apppayment") {
			window.$("body").addClass("fm-body-auth-mobile");	
			window.$("body").removeClass("fixed-top-init");			
			window.$(".fm-app-loading").remove();
		}	
				
	methodPayment()		
	getUserPagoCuotas()
	}, []);


	const getUserPagoCuotas = async() =>{
	    const dataq = new FormData();
	    var myHeaders = new Headers();
	    myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );
	    const response_service = await fetch(window.path_service+"/api/user/checkout/cuotas", { method:'POST',headers: myHeaders})
	    const response = await response_service.json()   
	    if (response.success && response.hasOwnProperty("data") && response.data.hasOwnProperty("pago_cuotas") && response.data.pago_cuotas ) {
	    	setPagoCuotas(response.data.pago_cuotas);
	    }
	    
	}


	const paydinamic = async(event) =>{
		var modaLoading = 
		  window.Swal.fire({
		    imageUrl: window.path_service+'/images/loading.png',
		    title: 'Cargando datos...',
		    showConfirmButton: false,
		    customClass: 'ms-loading-modal',
		      allowOutsideClick: false
		  });

			if ( window.getCookie("commerce_lead_token") !== "" && window.getCookie("commerce_lead_token") !== undefined ) {
				var myHeaders = new Headers();
			    const dataq = new FormData();

			    dataq.append("token", event.token );
			    dataq.append("brand", event.brand );
			    dataq.append("id_orden", localStorage.id_orden );
			    dataq.append("id_comercio", localStorage.getItem('comercioId') );
			    
			    myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );
				const response = await fetch(window.path_service+"/metodo_pago/payment/dinamic/payu",{method:'POST',body:  dataq, headers: myHeaders })
				const data = await response.json()

				if ( data.hasOwnProperty("status") && data.status ) {
					const id_orden =localStorage.id_orden;
			        window.Swal.fire({
			            icon: 'success',
			            title: data.message,
			            showConfirmButton: false,
			            timer: 2500
			          });         	

			         if ( ![null,undefined,0].includes(localStorage.id_orden) ) {
						localStorage.setItem('my_shopping_car', JSON.stringify([]) );
						localStorage.setItem('paymnet_cupon','');
						localStorage.removeItem("id_orden");
						window.location.href = "/confirmacion?process=finish&checkout=simple&orden="+id_orden;
			         }

					modaLoading.close();
				}else{
				  	window.Swal.fire({
				          icon: 'error',
				          title: data.message,
				          showConfirmButton: false,
				          timer: 2500
				    }); 
				    modaLoading.close();					
				}
			}

	}

	const methodPayment = async() =>{
	    const dataq = new FormData();
	    const response_service = await fetch(window.path_service+"/api/list/metodos_pagos", { method:'POST'})
	    const response = await response_service.json()   
	    if (response.success && response.hasOwnProperty("data") && response.data.length > 0 ) {
	    	setPasarelas(response.data)
	    }
	    
	}

	const cerrarModalPayu = () =>{
		window.$("#modalCheckoutPayu, #modalMisTarjetas, #modalConfrmpay").modal("hide");
	}

	const pagarButton = () => {
		pagar(metodoPago)
	}

	const checkoutSet = (item,xcard = null) => {
	  setMetodoPago(item)
	  if (["niubiz","payu","payu-card","manual"].includes(item)) {
	  		pagar(item,xcard)
	  }
	}

	const fcCart = (page) =>{
		window.location.href = window.path_service + "/" + page;
	}
	
	const pagar = async(item,xcard = null) =>{
	  let is_free = 0;

	  var modaLoading = 
	  window.Swal.fire({
	  		imageUrl: window.path_service+'/images/loading.png',
	  		title: 'Cargando datos...',
	      showConfirmButton: false,
	      customClass: 'ms-loading-modal',
	      allowOutsideClick: false
	  });

		let obj_shop_checkout = {
			id_orden:0,
			direccion:{},
			has_invoice:0,
			facturacion:{},
			has_complement:0,
			complement:{},
			shipping: {
				"date":"",
				"horario":"",
				"dt":"",
				"id":0,
				"price":0
			}
		};	  

	  	if (![undefined,"undefined",""].includes(localStorage.paymnet_shipping)) {
	        var paymnet_shipping = JSON.parse( localStorage.paymnet_shipping );
	        obj_shop_checkout.shipping = paymnet_shipping
      }

	  	if (![undefined,"undefined",""].includes(localStorage.facturacion)) {
	        var facturacion = JSON.parse( localStorage.facturacion );
	        obj_shop_checkout.facturacion = facturacion
	        obj_shop_checkout.has_invoice =1;
      }

	  	if (![undefined,"undefined",""].includes(localStorage.address)) {
	        var address = JSON.parse( localStorage.address );
	        obj_shop_checkout.direccion = address
      }      

      if ( window.getCookie("commerce_lead_token") !== "" && window.getCookie("commerce_lead_token") !== undefined ) {
		   const dataq = new FormData();
		   dataq.append("action", "ekonofresh_payment_dinamic" );
		   dataq.append("type", item );
		   if (form === "apppayment") {
		   	dataq.append("device", "app" );
		   }else{
		   	dataq.append("device", "desk" );
		   }

		   var reducirBolsa = "no";
		   if (![undefined,"undefined",""].includes(localStorage.reducirBolsa)) {
		    reducirBolsa = localStorage.reducirBolsa;
		   }

		   var moreComment = "";
		   if (![undefined,"undefined",""].includes(localStorage.moreComment)) {
		    moreComment = localStorage.moreComment;
		   }

		    dataq.append("type_order", localStorage.methodshopping );
		    dataq.append("reducirBolsa", reducirBolsa );
		    dataq.append("mas_comentarios", moreComment );

		    dataq.append("info_checkout",JSON.stringify( obj_shop_checkout) );
		    dataq.append("shipping_free", is_free );
		    dataq.append("comercio_id", localStorage.comercioId );
		    if (![undefined,"undefined",""].includes(localStorage.cupon)) {
		    	dataq.append("cupon", localStorage.cupon );
		    }

	        if (![undefined,"undefined",""].includes(localStorage.distritoPay)) {
	            dataq.append("distrito", localStorage.distritoPay );
	        }	        

			var myHeaders = new Headers();
			myHeaders.append("Authorization", "Bearer "+ window.getCookie("commerce_lead_token") );


			const response_service = await fetch(window.path_service+"/metodo_pago/api/payment-shop", { method:'POST',dataType: "json",body:  dataq , headers: myHeaders })
		   	const response = await response_service.json()
		   if (response.status) {

		   	if (item === "niubiz") {
		   		localStorage.id_orden = response.id_orden;

			    window.$('.eko-payment-niubiz').attr("action",response.script.action_form );
		         var fileref = document. createElement("script"); fileref.setAttribute("type", "text/javascript"); 
		         fileref.setAttribute ("charset", "utf-8"); 
		         fileref.setAttribute("src", response.script.url); 
		         fileref.setAttribute ("data-sessiontoken", response.script.sessiontoken );
		         fileref.setAttribute ("data-channel", "web"); 
		         fileref.setAttribute ("data-merchantid", response.script.merchantid);
		         fileref.setAttribute ("data-merchantlogo", response.script.merchantlogo );
		         fileref.setAttribute ("data-purchasenumber", response.script.purchasenumber);
		         fileref.setAttribute ("data-amount", response.script.amount);
		         fileref.setAttribute ("data-expirationminutes", response.script.expirationminutes );
		         fileref.setAttribute ("data-timeouturl", response.script.timeouturl );
		         document.getElementsByClassName ('eko-payment-niubiz') [0] .appendChild(fileref);         
		         setTimeout(function(){
		            window.$('#eko-payment-niubiz .start-js-btn').click().ready(function(){
		              modaLoading.close();
		            });
		         },2000);


		   	}else if (item === "payu") {
		        if (response.status) {
		        	localStorage.id_orden = response.id_orden;
		        	modaLoading.close();
		        	window.$("#modalCheckoutPayu").modal("show");
		        }
		   	}else if (item === "payu-card") {
		        if (response.status) {
		        	localStorage.id_orden = response.id_orden;
		        	modaLoading.close();
		        	paydinamic(xcard)
		        }
		   	}else{

		        if (response.status) {
		        	localStorage.id_orden = response.id_orden;
					if (form === "apppayment") {
						window.location.href = "/app/checkout/confirmation?device=app&process=finish&checkout=simple&orden="+response.id_orden;
					}else{
						window.location.href = "/confirmacion?process=finish&checkout=simple&orden="+response.id_orden;
					}

		        	modaLoading.close();
		        }

		   	}


      



		   }
      }

	}


	const MantenerMisProductos = () =>{
		changeMethodShopping("schedule")
		if (form === "apppayment") {
			window.location.href = "/app/despacho";
		}else{
			window.location.href = "/despacho";
		}
	}

	const DeleteProductNoExpress = async() =>{
		var modaLoading = 
		window.Swal.fire({
			imageUrl: window.path_service+'/images/loading.png',
			title: 'Cargando datos...',
			showConfirmButton: false,
			customClass: 'ms-loading-modal',
			allowOutsideClick: false
		});

	    const dataq = new FormData();
	    dataq.append("action", "remove_product_no_express" );
	    const response_service = await fetch(window.path_service+"/api/remove_product_no_express", { method:'POST',body:  dataq })
	    const response = await response_service.json()

	    
		modaLoading.close();
	    window.$("#modalListOrdenPedido").modal("hide");
	    myListCart();

	}

	return(
		<div>
	        <Header
	        	user = {user}
	        	myLazyLoad = {myLazyLoad}
	        	loadMenu = {loadMenu}
	        	loadTransversal = {loadTransversal}
	        	menus = {menus}
	        	transversal = {transversal}
	        	changeHasExpress = {changeHasExpress}
	        	changeMethodShopping = {changeMethodShopping}
	        	methodShopping = {methodShopping}
	        	expressActive = {expressActive}
		        subTotal = {subTotal}
		        miproductos = {miproductos}
		        list_cart = {myListCart}
		        handleMiproductos = {handleMiproductos}
		        handleSubTotal = {handleSubTotal}
		        removeProduct = {removeProduct}
	        />



<main  className="wrap-content page-interna">
  <div className="container-interna ms-payment ms-payment-checkout">
   <div className="ms-section">

      <div className="ms-payment-steps">
         <ul className="ms-content-steps js-steps-payment">
            <li className="item-step check" step="my-car">
               <div className="head-step">
                  <div className="icon-step" onClick={() => fcCart("carrito")} ><i className="fa fa-shopping-cart"></i></div>
               </div>
               <div className="body-step">
                  <span>Mi Carrito</span>
               </div>
            </li>
            <li className="item-step check" step="my-despacho">
               <div className="head-step">
                  <div className="icon-step" onClick={() => fcCart("despacho")} ><i className="fa fa-user"></i></div>
               </div>
               <div className="body-step">
                  <span>Despacho</span>
               </div>
            </li>
            <li className="item-step active" step="my-payment">
               <div className="head-step">
                  <div className="icon-step"><i className="fa fa-credit-card"></i></div>
               </div>
               <div className="body-step">
                  <span>Metodo de pago</span>
               </div>
            </li>
            <li className="item-step" step="my-confirmacion">
               <div className="head-step">
                  <div className="icon-step"><i className="fa fa-file-text-o"></i></div>
               </div>
               <div className="body-step">
                  <span>Confirmación</span>
               </div>
            </li>
         </ul>
      </div>
      <div className="ms-wizard-wrapper shop-payment">
         <div className="ms-lateral-a">
            <div className="ms-wizard-item">
               <h3 className="ms-form-title">
                  <i className="fa fa-truck" aria-hidden="true"></i> IDENTIFICACIÒN
               </h3>
               <div className="ms-tab-content js-identification">
                  <div className="ms-tab active" id="resument_user">
                     <div className="ms-item-addres">
                        <span>{user.email}</span>
                        <span>{user.complete_name}</span>
                        <span>{user.num_phone}</span>
                     </div>
                  </div>
               </div>
            </div>

            <div className="ms-wizard-item">
               <h3 className="ms-form-title">
                  <i className="fa fa-truck" aria-hidden="true"></i> DATOS PARA LA ENTREGA
               </h3>
               <div className="ms-tab-content">
                  <div className="ms-tab js-data-shipping active" id="resument_shipping">
                  </div>
               </div>
            </div>



            <div className="ms-wizard-item">
            <TarjetasGuardadas
            cards = {cards}
            synCards = {synCards}
            getMyCards = {getMyCards}
             />

               <h3 className="ms-form-title">METODO DE PAGO</h3>
               <div className="ms-tab-content">
                  <div className="js-pay-niubiz" style={{"display":"none"}}>
                     <form id="eko-payment-niubiz" className="eko-payment-niubiz">
                     </form>
                  </div>
                  <div className="ms-tab active" id="resument_payment">
                     <div className="ms-item-addres">
                        {
                        	methodShopping === "schedule" ?
                        	<ul className="lista-metodos">

                        	{
                        		pasarelas.map(
                        		(pago,indexpago) => 
                        		pago.schedule ?
		                           <li className="item-metodo js-niubiz" key={indexpago}>
		                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id={"metodo_pago_"+indexpago} onClick={() => checkoutSet(pago.codigo_pasarela) } />
		                              <label htmlFor={"metodo_pago_"+indexpago}>
		                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
		                              <span>{pago.nombre}</span>
		                              </label>
		                           </li>
		                           : null
                        		)
                        	}

	                           <li className="item-metodo js-contraentrega">
	                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id="metodo_pago_3" onClick={() => checkoutSet("pos_visa")}  />
	                              <label htmlFor="metodo_pago_3">
	                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
	                              <span>Pago contra entrega (POS crédito, débito, tarjetas de alimentos y pre pagadas)</span>
	                              </label>
	                           </li>


	                           <li className="item-metodo js-contraentrega">
	                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id="metodo_pago_4" onClick={() => checkoutSet("pago_contra_entrega")}  />
	                              <label htmlFor="metodo_pago_4">
	                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
	                              <span>Pago contra entrega (Efectivo, YAPE, Tunki)</span>
	                              </label>
	                           </li>


	                           <li className="item-metodo js-contraentrega-2" >
	                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id="metodo_pago_5" onClick={() => checkoutSet("pago_contra_entrega")}  />
	                              <label htmlFor="metodo_pago_5">
	                              <img src="https://ekonofresh.pe/images/contra-entrega.png" />
	                              <span>Pago contra entrega puntos BBVA (POS crédito y débito)</span>
	                              </label>
	                           </li>
	                           
                        	{
                        		"user_tipo_pago" in resumen && resumen.user_tipo_pago === 2 ?
		                           <li className="item-metodo js-niubiz">
		                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id="manual" onClick={() => showModalDeposito() } />
		                              <label htmlFor="manual">
		                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
		                              <span>DEPOSITO BANCARIO</span>
		                              </label>
		                           </li>
		                           : null
                        	}


                        	{
                        		pagoCuotas ?
		                           <li className="item-metodo" key="metodo_pago_cuotas">
		                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id={"metodo_pago_cuotas"} onClick={() => checkoutSet("pago_cuotas") } />
		                              <label htmlFor={"metodo_pago_cuotas"}>
		                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
		                              <span>Pago en cuotas</span>
		                              </label>
		                           </li>
		                           :
		                           null                        		
                        	}


	                        </ul>
	                           : null
                        }

                        {
                        	methodShopping === "express" || methodShopping === "recojotienda" ?
                        	<ul className="lista-metodos">
                        	{
                        		pasarelas.map(
                        		(pago,indexpago) => 
                        		pago.express ?
		                           <li className="item-metodo js-niubiz" key={indexpago}>
		                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id={"metodo_pago_"+indexpago} onClick={() => checkoutSet(pago.codigo_pasarela) } />
		                              <label htmlFor={"metodo_pago_"+indexpago}>
		                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
		                              <span>{pago.nombre}</span>
		                              </label>
		                           </li>
		                           : null
                        		)
                        	}

                        	{
                        		(
                        			localStorage.emailUser === "antony_riverag@hotmail.com" ||
                        			localStorage.emailUser === "abrahamkajatt@gmail.com"                          		
                        		)
                        		&&
                        		"user_tipo_pago" in resumen && resumen.user_tipo_pago === 2 ?
		                           <li className="item-metodo js-niubiz">
		                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id="manual" onClick={() => showModalDeposito() } />
		                              <label htmlFor="manual">
		                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
		                              <span>DEPOSITO BANCARIO</span>
		                              </label>
		                           </li>
		                           : null
                        	}

                        	{
                        		pagoCuotas ?
		                           <li className="item-metodo" key="metodo_pago_cuotas">
		                              <input type="radio" className="js_metodo_pago" name="metodo_pago" id={"metodo_pago_cuotas"} onClick={() => checkoutSet("pago_cuotas") } />
		                              <label htmlFor={"metodo_pago_cuotas"}>
		                              <img src="https://ekonofresh.pe/images/pago-tarjeta.png" />
		                              <span>Pago en cuotas</span>
		                              </label>
		                           </li>
		                           :
		                           null                        		
                        	}


	                        </ul>                      	
	                           : null
                        }

                         
                        <p className="eko-param-method-payment">Si elegiste tarjeta de crédito o debito como medio de pago, en este momento solo se ha hecho una reserva en tu tarjeta por el monto estimado más 10% en caso pueda existir alguna diferencia por pesos. El cobro final se realizará en el momento de despachar tu pedido con el valor real y exacto de tu entrega.</p>
                        <br></br>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="ms-lateral-b ms-despacho">
            <div className="ms-wizard-item">
               <div className="ms-wrap-item">
                  <div className="ms-table-item" style={{"marginBottom": "0"}}>
                     <div className="ms-resumen-title">Resumen de la compra</div>
	                     <div className="ms-scroll-table">
	                        <table className="js-resumen-product-cart">
	                        	<tbody>
			                        	{
			                        		"items" in resumen  && resumen.items.length > 0 ?
			                        				resumen.items.map((item,keyindex) =>

						                              <tr key = {keyindex}>
						                                 <td>
						                                    <div className="ms-item-product">
						                                       <div className="ms-wrap-img">
						                                          <img className="shop-lazy-image" alt={item.name} src={item.image} />
						                                       </div>
						                                       <div className="ms-wrap-detail">
						                                       		<p className="product-item__name">{item.name}</p>
						                                       		<div className="cantidad">({item.price_show} x {item.cantidad}) {item.unidadmedida} <span className="cant_tot_mon">S/. {item.total_sin_descuento}</span></div>

				                        							{
				                        								item.has_dsc_backo &&  item.descuentos.length > 0 ?
													                           			item.descuentos.map(
													                           				(descuento,index) =>
													                           				<div className="cantidad descuento-resumen">
													                           					{descuento.nombre_mostrar} <span className="cant_tot_mon">S/. {descuento.total_dcto}</span>
													                           				</div>
													                           			)								                           		
													                           	:null
								                        			}					                                            
						                                       </div>
						                                       
						                                       { item.has_express ?
						                                            <div className="icon-express">
						                                                <img src="/images/express.svg?1" className="img-express" alt="Freshmart" />
						                                            </div>
						                                            : null
						                                        }
						                                    </div>
						                                 </td>
						                              </tr>
						                            )
			                        		: null
				                        }
	                        	</tbody>
	                        </table>
	                     </div>
                  </div>
                  <div className="ms-back-shipping">
                     <a href="#"><i className="fa fa-angle-left"></i> Volver al carrito</a>
                  </div>
                  <div className="ms-body-wizard">
			              <div className="ms-table-item js-cart-block-sub-total" style={{ marginBottom : "0"}}>

		                        <div className="ms-sub-title">
		                           <strong>Subtotal</strong>
		                           <strong className="color-price js-subtot-cart" mount="00.00">S/. {subTotal}</strong>
		                        </div>

		                        <table className="ms-payment-detail">
		                        	<tbody className="table-resumen">
		                        	
		                        	{
		                        		"items" in resumen  && resumen.items.length > 0 ?
		                        		resumen.items.map((item,keyindex) =>
		                        			item.has_dsc_backo_tipo_2 &&
		                        			(
		                        				("producto" in item.descuentos) ||
		                        				("especial" in item.descuentos) 
		                        			)
		                        			 ?
			                        			<tr key = {keyindex} className="tr-rm-main">
			                        				{
			                        					Object.keys(item.descuentos).map(
			                        					(keyDesc, index) => 
			                        					keyDesc === "producto" || keyDesc === "especial" ?
			                        						item.descuentos[keyDesc].map(
				                        					(descpro, descindex) =>
				                        						descpro.tipo_adjustment === 2 ?
				                        						<tr className="tr-rm-main desc-cate" key={descindex}>
				                        							<td>
				                        								<div className="block-resumen resumen-descuento-prod" >
				                        									<span className="ms-grcolor">{descpro.nombre_mostrar}</span>
																			<span className="ms-pr-color">-S/{(descpro.monto_descuento) }</span>
																		</div>	
																	</td>	                        							
																</tr>
																: null
				                        					)
			                        						: null
			                        					)
			                        				}
			                        			</tr>
		                        			: null

		                        			)
		                        		: null
		                        	}

		                        	{
		                        		"descuentos_productos" in resumen  ?
		                        				Object.keys(resumen.descuentos_productos).map(
		                        					(keyDesc, index) => 
		                        					resumen.descuentos_productos[keyDesc].map(
		                        						(descpro, descindex) =>
		                        						descpro.tipo_adjustment === 2 ?

		                        						<tr className="tr-rm-main desc-cate" key={descindex}>
		                        							<td>
		                        								<div className="block-resumen resumen-descuento-prod" >
		                        									<span className="ms-grcolor">{descpro.nombre_mostrar}</span>
		                        									<span className="ms-pr-color">-S/{(descpro.monto_a_descontar) }</span>
		                        								</div>	
		                        							</td>	                        							
		                        						</tr>
		                        						: null
		                        					)
		                        				)
			                        		
		                        		:
		                        		null
		                        	}		                        	

		                        				<tr className="tr-rm-main tr-sub-total">
		                        					<td>
		                        						<div className="block-resumen resumen-subtotal-prod" >
											            	<span className="ms-grcolor">Sub Total Productos</span>
											                <span className="ms-pr-color">S/{(resumen.total_descuentos_productos) }</span>
											            </div>	
											        </td>	                        							
											    </tr>


		                        	{
		                        		"infocupon" in resumen && "nombre_mostrar" in  resumen.infocupon && "tipo_adjustment" in  resumen.infocupon && resumen.infocupon.tipo_adjustment === "1" ?

		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.infocupon.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.infocupon.monto_descuento) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}


		                        	{
		                        		"descuentos_globales" in resumen && "dia" in resumen.descuentos_globales ?
		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.descuentos_globales.dia.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.descuentos_globales.dia.monto_a_descontar) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}

		                        	{
		                        		"descuentos_globales" in resumen && "distrito" in resumen.descuentos_globales ?
		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.descuentos_globales.distrito.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.descuentos_globales.distrito.monto_a_descontar) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}


		                        	{
		                        		"descuentos_globales" in resumen && "orden" in resumen.descuentos_globales ?
		                        				<tr className="tr-rm-main">
		                        					<td>
		                        						<div className="block-resumen resumen-descuento-prod" >
											            	<span className="ms-grcolor">{resumen.descuentos_globales.orden.nombre_mostrar}</span>
											                <span className="ms-pr-color">-S/{(resumen.descuentos_globales.orden.monto_a_descontar) }</span>
											            </div>	
											        </td>	                        							
											    </tr>
		                        		:
		                        		null
		                        	}


	                              {
	                              	resumen.activeshippingprice ?
	                                  <tr className="tr-rm-main">
	                                    <td>
	                                    	<div className="block-resumen">
	                                    		<span className="ms-grcolor">Precio de envio</span>
		                        				<span className="ms-pr-color">S/{ (resumen.shipping_price).toFixed(2) }</span>
		                        			</div>	                                    	
	                                    </td>
	                                  </tr>
	                                  : null
	                              }

                              {"dctoorden" in resumen && "nombre_mostrar" in resumen.dctoorden ? 
	                                  <tr className="tr-rm-main">
	                                    <td>
	                                    	<div className="block-resumen">
	                                    		<span className="ms-grcolor">{resumen.dctoorden.nombre_mostrar}</span>
		                        				<span className="ms-pr-color">-S/{resumen.dctoorden.monto_a_descontar}</span>
		                        			</div>	                                    	
	                                    </td>
	                                  </tr>
                                  :null
                              }  

                              {"activedescuentoCupon" in resumen && resumen.activedescuentoCupon ? 
	                                  <tr className="tr-rm-main">
	                                    <td>
	                                    {
	                                    	<div className="block-resumen">
		                                    	<span className="ms-grcolor">{resumen.nombrecupon}</span>
					                        	<span className="ms-pr-color">-S/{resumen.mountdescuento}</span>
					                        </div>	                                    	
	                                    }
	                                    </td>
	                                  </tr>
                                  :null
                              }                                            
			                    	</tbody>

			                        <tfoot  className="table-resumen" style={{"borderTop": "1px solid #ccc"}}>
			                            <tr className="tr-rm-main">
				                            <td>
	                                    	<div className="block-resumen">
	                                    		<span className="ms-grcolor foot"><strong>Total</strong></span>
		                        				<span className="ms-pr-color foot"><strong className="ms-grcolor">S/{resumen.totalPrice}</strong></span>
		                        			</div>	 
		                        			</td>
			                            </tr>
			                        </tfoot>                           
			                    </table>
		                           
		                           
		                        <span className="ms-min-text">Pedido mínimo de S/.35 para poder hacer una compra</span>
		                        { 
		                        	resumen.nextstep && metodoPago !=="" ? 
		                        	<button className="ms-btn green js-btn-next-payment" onClick={pagarButton}>FINALIZAR COMPRA</button>
		                        	: null
		                        }
			              </div>                     
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
  </div>

<div className="modal fade" id="modalCheckoutPayu" role="dialog">
   <div className="modal-dialog" role="document">
      <div className="modal-content">
         <div className="modal-header">
            <button onClick={cerrarModalPayu}  type="button" className="close js-close-transfer" data-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button>
         </div>
         <div className="modal-body">
         	<FormPayu showAddCard={true} />
         </div>
      </div>
   </div>
</div>


<div className="modal fade" id="modalMisTarjetas" role="dialog">
   <div className="modal-dialog" role="document">
      <div className="modal-content">
         <div className="modal-header">
            <button onClick={cerrarModalPayu}  type="button" className="close js-close-transfer" data-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button>
         </div>
         <div className="modal-body">
		
			<div className="fm-container-block">
				{
					"cards" in window && window.cards.length > 0 ?
					<ul className="ms-addres-list js-list-cart">
					{
						window.cards.map(
							(xcard,xindex) =>
								<li key={xindex}>
									<label className="ms-item" for="addressitem">
										<span>{xcard.card}</span>
										<span className="cardband">{xcard.brand}</span>
								        <span className="ms-radio-style">Tarjeta Activa</span>
								    </label>
								    <div className="card-action">
								    	<a className="ms-pay-card"  onClick={() => checkoutSet("payu-card",xcard) }>
								    		<span>pagar</span>
								    	</a>
								    							    
									    <a className="ms-delete-card" 
									    onClick={() => handledeleteItem(xcard) }
									    >Eliminar Tarjeta</a>
								    </div>
								</li>
							)
					}
					</ul>			
					:
					<p>No tienes tarjetas guardadas.</p>
				}
			</div>

         </div>
      </div>
   </div>
</div>

</main>

<div className="modal fade" id="modalConfrmpay" role="dialog" aria-labelledby="modalEditAddres">
   <div className="modal-dialog" role="document">
      <div className="modal-content">
         <div className="modal-header">
         <h3 className="ms-form-title"><i className="fa fa-credit-card " aria-hidden="true"></i> DEPOSITO BANCARIO</h3>
            <button onClick={cerrarModalPayu}  type="button" className="close js-close-transfer" data-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button>
         </div>
         <div className="modal-body">

          <div className="text-sm"> 
            <ul className="list-pay-transferences">
              <li><b>Banco:</b></li>   
              <li>BCP</li>
              <li><b></b></li>
              <li>193-2229497-0-70</li>
              <li><b>CCI:</b></li>
              <li>002-19300222949707016</li>
            </ul>

            <ul className="list-pay-transferences">
              <li><b>Banco:</b></li>   
              <li>INTERBANK</li>
              <li><b></b></li>
              <li>200-3002015461</li>
              <li><b>CCI:</b></li>
              <li>003-200-003002015461-30</li>
            </ul>            
            <div className="block-amount js-block-amount-checkout">
              <span className="js-total-payment">Titular: FRESHMART S.A RUC: 20539065751</span>
            </div>
          </div>


            <div className="form-payment-transferences">
                  <div className="visible">
                     <div className="relative py-3">
                        <button className="ms-btn green js-btn-save-transferences" 
                        onClick={() => checkoutSet("manual") } >Enviar</button>
                     </div>

                  </div>
            </div>
         </div>
      </div>
   </div>
</div>

	<div className="modal fade" id="modalListOrdenPedido" tabIndex="-1" role="dialog" aria-labelledby="modalListOrdenPedido">
	  <div className="modal-dialog" role="document">
	    <div className="modal-content">
	      <div className="modal-header">
	        <h3 className="ms-form-title">¿Estas comprando en modalidad Express y algunos productos NO SON EXPRESS?</h3>
	      </div>
			<div className="container-tabla">
			   <div className="campo-detalle">
				   <ul className="lista-detalle head">
				      <li className="fila-detalle">
				         <div className="item-detalle1"><span>SKU</span></div>
				         <div className="item-detalle2"></div>
				         <div className="item-detalle3">
				            <span>PRODUCTO</span>
				         </div>
				         <div className="item-detalle4"><span>PRECIO</span></div>
				         <div className="item-detalle5"><span>CANTIDAD</span></div>
				         <div className="item-detalle6"><span></span></div>
				         <div className="item-detalle7"><span>TOTAL</span></div>
				      </li>
				   </ul>			      
			   </div>
			   <ul className="lista-detalle">
			   {
			   	validateproductos.map(
			   		(product,index) =>
				    <li key = {index}  className="fila-detalle">
				         <div className="item-detalle1"><span>{product.sku}</span></div>
				         <div className="item-detalle2"></div>
				         <div className="item-detalle3"><p>{product.nombre}</p></div>
				         <div className="item-detalle4"><span>s/.{product.price}</span></div>
				         <div className="item-detalle5"><span>{product.cantidad}</span></div>
				         <div className="item-detalle6"><span></span></div>
				         <div className="item-detalle7"><span>s/.{product.total}</span></div>
				    </li>

			   	)
			   }
			   </ul>
			</div>
			<div className="content-buttons">
			   <div className="content-but">
			   		<div onClick={DeleteProductNoExpress}  className="button-agregar"><button type="button" className="btn-form1 btn-select">ELiminar productos No Express</button></div>
			   		<div onClick={MantenerMisProductos} className="button-agregar"><button type="button" className="btn-form1">Mantener mis productos</button></div>
			   </div>
			</div>



	    </div>
	  </div>
	</div>


	        <Footer />

		</div>
	)
}

export default PagePayment;